<script lang="ts">
	export let width: number
</script>

<div class="col-span-{width}">
	<div class="h-[6px] w-[80px] bg-primary-500" />
</div>
